import React from "react";
import SvgIcon from "@home/components/SvgIcon";
import classNames from "classnames";
import { joinDate } from "@dbl/core/date";
import type { TDateRange, TDateGranularity } from '@dbl/core/date';
import './index.scss';

/**
 * 主要用于 不同的时间选择器的相同的button显示
 * @param props
 * ref 是为了用于button时, 弹窗组件内置click生效
 * @constructor
 */
interface ITimeRangeDisplayProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'prefix'> {
  prefix: string;
  timeRange: TDateRange;
  granularity: TDateGranularity;
}

const TimeRangeDisplay = (props: ITimeRangeDisplayProps) => {
  const { prefix, timeRange, granularity, className, ...rest } = props;
  
  const text = joinDate(timeRange, granularity);
  
  return (<div className={classNames('dbl-time-range-display', className)} {...rest}>
    <SvgIcon type={'date'}/>
    <span className={'dbl-time-range-display-label'} title={prefix}>{prefix}</span>
    <span className={'dbl-time-range-display-times'}>{text}</span>
  </div>);
};

export default TimeRangeDisplay;